import React from "react";
import { PACK_IMAGE, chapters } from "../data/content";
import { SectionHeading } from "./SectionHeading";
export function ContentSection() {
  return <section id="contenido" className="bg-white py-16 md:py-24" data-id="element-85" data-mp="uq42ync1bwll">
      <div className="wrap" data-id="element-86" data-mp="qpaffv2i8jt8">
        <SectionHeading eyebrow="El libro principal" title={<>
              Tu iPhone, Tu Estudio: <span className="text-gold-dark" data-id="element-88" data-mp="gsflzql399lt">6 partes</span>
            </>} intro="Una guía visual con explicaciones claras, prácticas guiadas y referencias para volver a consultar cada vez que vayas a fotografiar o grabar." data-id="element-87" data-mp="qspy17ve0aze" />

        <div className="mt-12 grid items-start gap-8 lg:grid-cols-[360px_1fr]" data-id="element-89" data-mp="735p7xfav2rd">
          <div className="mx-auto w-full max-w-[300px] overflow-hidden rounded-2xl bg-night p-5 shadow-[0_20px_50px_rgba(20,39,85,0.18)] lg:sticky lg:top-6 lg:max-w-none" data-id="element-90" data-mp="322aje8zncrq">
            <img src={PACK_IMAGE} alt="Libro principal Tu iPhone, Tu Estudio dentro del pack CNS" width={1024} height={1536} loading="lazy" className="block h-auto w-full" data-id="element-91" data-mp="3p7pgodmnfcjk" />
          </div>

          <div className="grid gap-4 sm:grid-cols-2" data-id="element-92" data-mp="38jw6k16mpugt">
            {chapters.map(chapter => <article key={chapter.number} className="flex gap-4 rounded-2xl border border-line bg-mint p-5 md:p-6" data-id="element-93" data-mp="3dj0e6ndwnk51">
                <span className="display-title text-[44px] leading-none text-gold-dark" data-id="element-94" data-mp="53yqjblsdsak">{chapter.number}</span>
                <div data-id="element-95" data-mp="92oc3rgzag5a">
                  <span className="text-[11px] font-bold uppercase tracking-[1.5px] text-muted" data-id="element-96" data-mp="3radr3ihb5jr3">{chapter.area}</span>
                  <h3 className="display-title mt-1 text-[26px] leading-none text-ink" data-id="element-97" data-mp="3krgj25xsoo">{chapter.title}</h3>
                  <p className="mt-2 text-[15px] text-muted" data-id="element-98" data-mp="2fuyw2k8nt1ym">{chapter.body}</p>
                </div>
              </article>)}
          </div>
        </div>
      </div>
    </section>;
}